import { CheckCircle } from 'lucide-react';

import { Icon } from '@@/Icon';

export function CelebrationEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-8 text-center">
      <Icon
        icon={CheckCircle}
        className="w-12 text-success-8 th-highcontrast:text-success-3 th-dark:text-success-3"
      />
      <p className="m-0 text-lg font-semibold text-gray-9 th-highcontrast:text-white th-dark:text-gray-true-9">
        All governance steps complete
      </p>
      <p className="m-0 text-gray-7 th-highcontrast:text-white th-dark:text-gray-true-7">
        Your Portainer instance is fully configured. Nice work!
      </p>
    </div>
  );
}
